import { Injectable } from "@angular/core";
import { ExploreService } from "@spotter/services/sightings/explore-service";
import { FilterService } from "@spotter/services/sightings/filter-service";
import { QuestionsService } from "@spotter/services/sightings/questions-service";

@Injectable({
    providedIn: 'root'
})
export class SightingInitialiser {

    callbackFunction!: Function;

    constructor(public explore: ExploreService, public filter: FilterService, public questions: QuestionsService) { }

    initialise(callbackFunction: Function): Promise<boolean> {
        this.callbackFunction = callbackFunction;

        return new Promise(resolve => {
            // Loads the sightings and runs the filter
            this.explore.getSightings().subscribe({
                next: async () => {
                    await this.questions.initialise();
                    await this.filter.initialise();
                    this.callbackFunction();
                    resolve(true);
                }
            })
        });
    }
}
